import React from 'react';
import { ContainerComponent, wrap } from 'AppReact';
import { SecondaryTextXs, CSVLink, SecondaryTextSm, Icon, SecondaryTextXs400 } from 'atoms';
import Controller from './controller';
import {
  FlexCenterWrapper, Mr2, RelativeWrapper, CursorPointerWrapper, GenericWrapper,
  AbsoluteRightTopWrapper, BorderedCard, HoverPrimary50BackgroundWrapper, Py2, Px5
} from 'wrappers';
import { CSVSvg, PDFSvg, DownloadDocumentSvg, EmailSvg } from "components/icons";
import internalState from './internalState';


export const definition = {
  name: 'ExportMakeReadyCards',
  controller: Controller,
  initialProps: ({ csvData, fileName, fetchingPDF, showSubscribe, hidePdf, subscribeComingSoon }) => ({
    csvData, fileName,
    containerRef: React.createRef(),
    fetchingPDF,
    showSubscribe,
    hidePdf,
    subscribeComingSoon
  }),
  props: internalState,
  elements: [
    {
      wrapper: RelativeWrapper,
      name: 'RelativeWrapper',
      ref: ({ containerRef }) => containerRef,
      elements: [
        {
          wrapper: wrap(FlexCenterWrapper, CursorPointerWrapper),
          name: 'Selector',
          isButton: true,
          bindings: ({ isOpen, containerRef }) => ({ isOpen, containerRef }),
          elements: [
            {
              component: wrap(SecondaryTextXs, Mr2),
              name: 'Text',
              displayValue: ({ }) => 'Export'
            },
            {
              component: Icon,
              name: 'Icon',
              displayValue: ({ }) => DownloadDocumentSvg({})
            }
          ]
        },
        {
          wrapper: AbsoluteRightTopWrapper,
          name: "DropdownWrapper",
          displayState: ({ }) => ({ top: '34px' }),
          renderIf: ({ isOpen }) => isOpen,
          elements: [
            {
              wrapper: BorderedCard,
              name: 'Wrapper',
              displayState: ({ }) => ({ background: '#FFFFFF', borderRadius: '8px', padding: '0px' }),
              elements: [
                {

                  wrapper: CursorPointerWrapper,
                  name: 'Pdf',
                  isButton: true,
                  renderIf: ({ hidePdf }) => !hidePdf,
                  bindings: ({ isOpen, csvData, fileName, fetchingPDF }) => ({ isOpen, csvData, fileName, fetchingPDF }),
                  elements: [
                    {
                      wrapper: wrap(FlexCenterWrapper, HoverPrimary50BackgroundWrapper),
                      name: '__transparent__',

                      elements: [
                        {
                          component: wrap(Icon, Mr2),
                          name: 'Icon',
                          displayValue: ({ }) => PDFSvg({})
                        },
                        {
                          component: SecondaryTextSm,
                          name: 'Text',
                          displayValue: ({ }) => 'PDF'
                        }
                      ]
                    },
                  ]
                },
                {
                  wrapper: CursorPointerWrapper,
                  name: 'Csv',
                  isButton: true,
                  bindings: ({ isOpen }) => ({ isOpen }),
                  elements: [
                    {
                      wrapper: wrap(FlexCenterWrapper, HoverPrimary50BackgroundWrapper),
                      name: '__transparent__',
                      elements: [
                        {
                          component: wrap(CSVLink, Mr2),
                          name: 'CsvExport',
                          bindings: ({ isOpen }) => ({ isOpen }),
                          displayValue: ({ fileName, csvData }) => ({
                            filename: fileName, data: csvData,
                            children: [<div className='flex items-center'><CSVSvg key={1} /> <div className='ml-2'>CSV</div></div>]
                          })
                        },
                      ]
                    },
                  ]
                },
                {
                  wrapper: CursorPointerWrapper,
                  name: 'Subscribe',
                  isButton: true,
                  bindings: ({ }) => ({}),
                  renderIf: ({ showSubscribe }) => showSubscribe,
                  elements: [
                    {
                      wrapper: wrap(FlexCenterWrapper, HoverPrimary50BackgroundWrapper),
                      name: '__transparent__',
                      elements: [
                        {
                          component: wrap(Icon, Mr2),
                          name: 'Icon',
                          displayValue: ({ }) => EmailSvg({ width: 18, height: 17 })
                        },
                        {
                          component: SecondaryTextSm,
                          name: 'Text',
                          displayValue: ({ }) => 'Subscribe'
                        }
                      ]
                    },
                  ]
                },
                {
                  wrapper: wrap(wrap(GenericWrapper, Py2), Px5),
                  name: 'SubscribeComingSoon',
                  renderIf: ({ subscribeComingSoon }) => subscribeComingSoon,
                  elements: [
                    {
                      wrapper: FlexCenterWrapper,
                      name: 'Subscribe',
                      elements: [
                        {
                          component: wrap(Icon, Mr2),
                          name: 'Icon',
                          displayValue: ({ }) => EmailSvg({ width: 18, height: 17 })
                        },
                        {
                          component: SecondaryTextSm,
                          name: 'Text',
                          displayValue: ({ }) => 'Subscribe'
                        }
                      ]
                    },
                    {
                      component: SecondaryTextXs400,
                      name: 'ComingSoon',
                      displayValue: ({ }) => 'Coming Soon'
                    }
                  ]
                }
              ]
            }
          ]
        },
      ]
    },
  ]
}

export default wrap(ContainerComponent(definition), FlexCenterWrapper);